import React, { FunctionComponent, useEffect, useState } from 'react';

import '@/css/toast.scss'

export enum ToastMessageType {
    ALERT = 'alert',
    SUCCESS = 'success',
    WARNING = 'warning'
}

export interface IToastVariables {
    messageType?: ToastMessageType;
    message?: string;   
}

interface ToastNotificationProps {
    show?: boolean
    closeToast:() => void
    messageType?: ToastMessageType
    children?: JSX.Element | JSX.Element[] | string | string[]
} 

const ToastNotification: FunctionComponent<ToastNotificationProps> = ({show, closeToast, messageType, children}) => {

    const [isClosing, setIsClosing] = useState<boolean>(false)

    useEffect(()=> {
        if(show) {
            setTimeout(()=> setIsClosing(true), 4500)
            setTimeout(()=> closeToast(), 5000)
        }
    },[show]);

    return (
        <div id="react-toast" className={`toast-notification ${messageType} ${show? 'show': ''} ${isClosing ? 'is-closing' : ''}`}>
            {children}
        </div>)
}

export default ToastNotification;